import { h, render, Component } from 'preact';


export default class Desktop extends Component {
    constructor() {
        super();

        this.state = {
            current: 0,
            autoplay: 0,
        };

        this.setCurrent = (current) => {
            this.setState({
                current,
            });
        };
    }

    render() {
        const {
            data,
        } = this.props;

        const currentAbility = data[this.state.current];

        return (
            <div className="o-media-layout u-spacing-220">
                <div className="o-media-layout__content">
                    <div className="c-frame">
                        <div className="o-aspect o-aspect--16x9">
                            <iframe
                                width="560"
                                height="315"
                                src={`https://www.youtube.com/embed/${currentAbility.youtubeId}?showinfo=0&rel=0&autoplay=${this.state.autoplay}`}
                                frameBorder="0"
                                allow="autoplay; encrypted-media"
                                allowFullScreen
                            />
                        </div>
                    </div>
                    <div className="c-media-controls">
                        <ul className="o-list-unstyled c-media-controls__list">
                            {data.map((ability, abilityIndex) => {
                                if (ability.key === false) {
                                    return (
                                        <li key="divider" className="c-media-controls__item c-media-controls__item--divider" />
                                    );
                                }

                                const onClick = () => {
                                    this.setCurrent(abilityIndex);
                                    this.setState({ autoplay: 1 });
                                };

                                const className = `c-thumb ${abilityIndex === this.state.current && 'is-active'}`;

                                return (
                                    <li key={ability.key} className="c-media-controls__item">
                                        <button className={className} onClick={onClick}>
                                            <span className="o-aspect">
                                                <img src={`${window.versionedAssetPath}${ability.thumbnail}`} alt="" />
                                            </span>
                                        </button>
                                        <div className="c-media-controls__label">{ability.key}</div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
                <div className="o-media-layout__aside">
                    <div className="c-thumb c-thumb--big u-spacing-40">
                        <span className="o-aspect">
                            <img src={`${window.versionedAssetPath}${currentAbility.thumbnail}`} alt="" />
                        </span>
                    </div>

                    <h3 className="c-heading-18 u-color-putty u-spacing-40">{currentAbility.title}</h3>
                    {currentAbility.description.map(line => <p dangerouslySetInnerHTML={{ __html: line }} />)}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/AbilitiesPlayer/scenes/Desktop/index.jsx